// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3KzJp","dragIcon":"SortableItem_dragIcon__w6GBQ","disabled":"SortableItem_disabled__1B91W"};